var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Form } from 'formik';
import { useMediaQuery } from '@mui/material';
import Typography from '@mui/material/Typography';
import AlertBox from '../../../../uikit/info/AlertBox';
import { Spacer } from '../../../../uikit/misc/Spacer';
import { Col, Row } from '../../../../uikit/grid';
import { CheckoutTable } from './parts/CheckoutTable';
import { SelectFormikField } from '../../../../components/molecules/FormFields/SelectField';
import { CheckboxFormikField } from '../../../../components/molecules/FormFields/CheckboxField';
import { RadioGroupFormikField } from '../../../../components/molecules/FormFields/RadioGroupField';
import helpers from './helpers';
import { additionalChargeCalculatorPageFormModel } from './formModel';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
import { FormikForm } from '../../../../components/molecules/FormikForm';
import { CALCULATOR_DECISIONS, } from './formModel.types';
import { mainFormSlice } from '../../../../store/mainForm/mainForm.slice';
import { MAIN_FORM_STEPS } from '../../../../store/mainForm/mainForm.types';
import { GERMAN_FEDERAL_STATES } from '../../../../apiServices/additionalCharge.service';
import { useOnDepsUpdate } from '../../../../hooks/useOnDepsUpdate.hook';
import { MainFormFooter } from '../../../../components/molecules/MainFormFooter';
var t = getTranslation(translations);
var PATHS = additionalChargeCalculatorPageFormModel.paths, SELECTORS = additionalChargeCalculatorPageFormModel.selectors, HELPERS = additionalChargeCalculatorPageFormModel.helpers, initialValues = additionalChargeCalculatorPageFormModel.initialValues, validationSchema = additionalChargeCalculatorPageFormModel.validationSchema;
var decisionColProps = { xs: 12 };
var mapStateToProps = function (state) { return (__assign({}, mainFormSlice.selectors.getAdditionalChargeData(state))); };
var mapDispatchToProps = function (dispatch) { return ({
    onFederalStateChange: function (federalState) {
        dispatch(mainFormSlice.actions.makeAdditionalChargeCalculations(federalState));
    },
    saveDecision: function (loanAmount, availableEquity) {
        dispatch(mainFormSlice.actions.saveAdditionalChargeDecision(loanAmount, availableEquity));
    },
    goToNextPage: function () {
        dispatch(mainFormSlice.actions.setActiveStep(MAIN_FORM_STEPS.ADVICE_PAGE));
    },
    goToPrevPage: function () {
        dispatch(mainFormSlice.actions.setActiveStep(MAIN_FORM_STEPS.APPLICANT_OCCUPATION_PAGE));
    },
}); };
export var AdditionalChargeCalculatorPage = function (_a) {
    var onFederalStateChange = _a.onFederalStateChange, saveDecision = _a.saveDecision, goToPrevPage = _a.goToPrevPage, goToNextPage = _a.goToNextPage, tableProps = __rest(_a, ["onFederalStateChange", "saveDecision", "goToPrevPage", "goToNextPage"]);
    tableProps = __assign(__assign({}, tableProps), { federalState: typeof tableProps.federalState === 'undefined'
            ? GERMAN_FEDERAL_STATES.UNKNOWN
            : tableProps.federalState });
    var isSingleColumnView = useMediaQuery(function (theme) {
        return theme.breakpoints.down('lg');
    });
    return (React.createElement(FormikForm, { initialValues: __assign(__assign({}, initialValues), { federalState: tableProps.federalState }), validateOnChange: false, validationSchema: validationSchema, onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
            var decision, derivedUnderfunding, underfunding, _a, loanAmount, availableEquity, isDecisionRequired;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        decision = values.decision, derivedUnderfunding = values.derivedUnderfunding;
                        underfunding = derivedUnderfunding;
                        _a = tableProps, loanAmount = _a.loanAmount, availableEquity = _a.availableEquity;
                        isDecisionRequired = HELPERS.isDecisionRequired(values);
                        if (!(isDecisionRequired &&
                            decision === CALCULATOR_DECISIONS.ADD_UNDERFUNDING_TO_LOAN_AMOUNT)) return [3 /*break*/, 2];
                        return [4 /*yield*/, saveDecision(loanAmount + underfunding, 0)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!(isDecisionRequired &&
                            decision === CALCULATOR_DECISIONS.ADD_UNDERFUNDING_TO_AVAILABLE_EQUITY)) return [3 /*break*/, 4];
                        return [4 /*yield*/, saveDecision(0, availableEquity + underfunding)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        actions.setSubmitting(false);
                        goToNextPage();
                        return [2 /*return*/];
                }
            });
        }); } }, function (formik) {
        var values = formik.values;
        var _a = useMemo(function () {
            return helpers.getDerivedDataCortege(tableProps, !!SELECTORS.IS_BROKER_FEE_PRESENTED(values), SELECTORS.DECISION(values));
        }, [
            SELECTORS.IS_BROKER_FEE_PRESENTED(values),
            SELECTORS.DECISION(values),
            tableProps.requestId,
        ]), derivedData = _a[0], derivedUnderfunding = _a[1];
        var _b = useMemo(function () {
            return [
                helpers.makeCheckoutTableRows(derivedData),
                {
                    title: t.underfundingRow,
                    value: helpers.getUnderfundingValueToShow(derivedData.underfunding),
                },
            ];
        }, [derivedData]), checkoutTableRows = _b[0], checkoutTableTotal = _b[1];
        var decisionOptions = useMemo(function () {
            return helpers.makeDecisionOptions(tableProps.loanAmount, tableProps.availableEquity, derivedUnderfunding);
        }, [derivedData]);
        useEffect(function () {
            formik.setFieldValue(PATHS.DERIVED_UNDERFUNDING, derivedUnderfunding);
        }, [derivedUnderfunding]);
        var federalStateOptions = useMemo(function () {
            return HELPERS.makeFederalStateOptions(values);
        }, [SELECTORS.FEDERAL_STATE(values)]);
        useOnDepsUpdate(function () {
            var federalState = SELECTORS.FEDERAL_STATE(values);
            if (typeof federalState !== 'undefined') {
                onFederalStateChange(federalState);
            }
        }, [SELECTORS.FEDERAL_STATE(values)]);
        var shouldRenderWarning = SELECTORS.FEDERAL_STATE(values) === GERMAN_FEDERAL_STATES.UNKNOWN;
        return (React.createElement(Form, { noValidate: true },
            React.createElement(Typography, { variant: 'h4' }, t.title),
            React.createElement(Spacer, { size: 1 }),
            React.createElement(Typography, null, t.subTitle),
            React.createElement(Spacer, { size: 4 }),
            React.createElement(Row, null,
                React.createElement(Col, { lg: 6, md: 10, sm: 12 },
                    React.createElement(CheckoutTable, { rows: checkoutTableRows, total: checkoutTableTotal }),
                    React.createElement(Spacer, { size: 3 })),
                React.createElement(Col, { lg: 5, md: 12, offset: { lg: 1 } },
                    React.createElement(CheckboxFormikField, { name: PATHS.IS_BROKER_FEE_PRESENTED, label: t.isBrokerFeePresented }),
                    React.createElement(SelectFormikField, { name: PATHS.FEDERAL_STATE, label: t.federalStateLabel, description: t.federalStateDescription, options: federalStateOptions }),
                    shouldRenderWarning && (React.createElement(React.Fragment, null,
                        React.createElement(AlertBox, __assign({ type: "warning", title: t.federalStateIsNotPresented_title, content: t.federalStateIsNotPresented_description }, (!isSingleColumnView && { icon: false }))),
                        React.createElement(Spacer, { size: 3 }))),
                    React.createElement(Spacer, { size: 1 }))),
            React.createElement(RadioGroupFormikField, { label: t.decisionLabel, name: PATHS.DECISION, colProps: decisionColProps, options: decisionOptions, disabled: !HELPERS.isDecisionRequired(values) }),
            React.createElement(Spacer, { size: 1 }),
            React.createElement(MainFormFooter, { isForwardDisabled: !!formik.isSubmitting, onBackwardBtnClick: goToPrevPage })));
    }));
};
export default connect(mapStateToProps, mapDispatchToProps)(AdditionalChargeCalculatorPage);
